module.exports = __webpack_public_path__ + "images/300959c8dc919a70a0e206c47378e879.png";